import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { WhatsAppButton } from '@/components/WhatsAppButton';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight } from 'lucide-react';

// Simple blog page - content will be managed from admin panel in future
export const BlogPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="inline-flex items-center gap-2 bg-primary/10 text-primary px-4 py-2 rounded-full mb-6"
            >
              <BookOpen className="w-5 h-5" />
              <span className="font-medium">Blog</span>
            </motion.div>
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="text-3xl sm:text-4xl lg:text-5xl font-bold font-display text-foreground mb-4"
            >
              Teknik Servis Rehberi
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="text-lg text-muted-foreground max-w-2xl mx-auto"
            >
              Cihazlarınız hakkında faydalı bilgiler ve tamir rehberleri
            </motion.p>
          </div>

          {/* Coming Soon */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="text-center py-16"
          >
            <div className="max-w-md mx-auto bg-card rounded-2xl border shadow-card p-8">
              <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6">
                <BookOpen className="w-8 h-8 text-primary" />
              </div>
              <h2 className="text-2xl font-bold mb-4">Yakında!</h2>
              <p className="text-muted-foreground mb-6">
                Blog içeriklerimiz çok yakında sizlerle olacak. Cihaz bakımı, arıza çözümleri ve teknik ipuçları hakkında faydalı yazılar paylaşacağız.
              </p>
              <Button asChild>
                <Link to="/servis">
                  Servis Talebi Oluştur <ArrowRight className="w-4 h-4 ml-2" />
                </Link>
              </Button>
            </div>
          </motion.div>
        </div>
      </main>
      
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

// For backwards compatibility with existing routes
export const BrandDetailPage = () => {
  return <BlogPage />;
};

export default BlogPage;
